/**
 * Base URL da API HTTP.
 * - Dev local: backend em :4000
 * - Produção: prefixo /api (proxy Nginx → backend)
 */
export function getApiBase() {
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL.replace(/\/+$/, '');
    }

    if (typeof window !== 'undefined') {
        const { protocol, hostname } = window.location;
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return `${protocol}//${hostname}:4000`;
        }
        return '/api';
    }

    return '/api';
}
